module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/cloud-2-0354bb1b3e6709b1eaa5b7f0f4648b8c.svg";